import { render, staticRenderFns } from "./RequestCompOffBalanceModal.vue?vue&type=template&id=674b63c6&scoped=true&"
import script from "./RequestCompOffBalanceModal.vue?vue&type=script&lang=js&"
export * from "./RequestCompOffBalanceModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestCompOffBalanceModal.vue?vue&type=style&index=0&id=674b63c6&lang=scss&scoped=true&"
import style1 from "./RequestCompOffBalanceModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b63c6",
  null
  
)

export default component.exports